<template>
  <div class=''>
     <el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
      <el-tab-pane label="会诊列表" name="reportList"></el-tab-pane>
      <el-tab-pane label="发起会诊" name="Initiate"></el-tab-pane>
    </el-tabs>
    <reportlists v-if='activeName2 === "reportList"'></reportlists>
    <initiates v-if='activeName2 === "Initiate"'></initiates>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
// import { formatDate } from '@/utils/index.js'
import common from '@/utils/common.js'
import reportlists from './reportList'
import initiates from './Initiate'
export default {
  name: 'Consultation',
  data() {
    return {
      tableloading: false,
      isShowInitiate: false,
      search: {
        Status: 0,
        patientName: '',
        patientNo: '',
        RegNo: '',
        PerformId: '',
        PatientType: '',
        SubmitterName: '',
        DateArray: [new Date(), new Date()],
        Modality: '',
        bodyPart: '',
        DepartId: '',
        PageIndex: 1,
        PageCount: 10,
        CompleteStatus: 0,
        IsShowAll: 1
      },
      getTime: common.SettingsTime.value,
      getqueryType: common.SettingsqueryType.value,
      ReportList: [],
      timeType: 0,
      isActive: false,
      navHeight: 102,
      activeName2: 'reportList',
      currentPage: 1,
      tableHeader: [{
        prop: 'srcHospitalName',
        label: '来源医院'
      }, {
        prop: 'name',
        label: '诊断医生'
      }]
    }
  },
  components: {
    reportlists,
    initiates
  },
  beforeMount() {
  },
  mounted() {

  },
  created() {
    this.handleClick(this.activeName2)
  },
  methods: {
    handleClick(tab, event) {
      if (tab.name === 'reportList') {
        this.isShowInitiate = false
      }
      if (tab.name === 'Initiate') {
        this.isShowInitiate = true
      }
    }
  },
  watch: {

  },
  filters: {

  }

}

</script>
<style rel='stylesheet/scss' lang='scss' scoped>
  .el-tabs{
    padding: 0px 20px;
    margin-top: 20px;
  }
</style>
